import { Box, Grid } from "@mui/material";
import { IUser } from "../../../types/user";
import StandardTable from "../../tables/StandardTable";
import { IPhoneTotal } from "../../userProfile/reporting/Reporting";
import { downloadExcel, downloadPdf, convertAllDates, camelToNormal } from "../../../utils/function";

const ReportCallTable = (props: ChildProps) => {
  const { phoneTotals, user, dateStart, loading } = props;

  const projectColumns = [
    {
      Header: "Name",
      accessor: (rowData: any) => {
        return <strong style={{ cursor: "pointer" }}>{rowData.name}</strong>;
      },
    },
    {
      Header: "Outbound Calls",
      accessor: (rowData: any) => rowData.outboundCalls,
    },
    {
      Header: "Inbound Calls",
      accessor: (rowData: any) => rowData.inboundCalls,
    },
    {
      Header: "Missed Calls",
      accessor: (rowData: any) => rowData.missedCalls,
    },
    {
      Header: "Average Duration Outbound (s)",
      accessor: (rowData: any) => rowData.averageDurationOutbound ? rowData.averageDurationOutbound.toFixed(2) : "0" ,
    },
    {
      Header: "Average Duration Inbound (s)",
      accessor: (rowData: any) => rowData.averageDurationInbound ? rowData.averageDurationInbound.toFixed(2) : "0",
    },
  ];

  const download = (type: string, data: any) => {
    let headers: any[] = [];
    for (const [key] of Object.entries(phoneTotals[0])) {
      if (key !== "id") {
        headers.push({
          label: camelToNormal(key),
          id: key,
        });
      }
    }

    let columnWidths = phoneTotals.map(() => {
      if (type === "excel") {
        return {
          name: 15,
          outboundTotal: 15,
          outboundBusiness: 15,
          outboundNonBusiness: 15,
          incomingTotal: 15,
          incomingBusiness: 15,
          incomingNonBusiness: 15,
          incomingAnsweredBusiness: 15,
          incomingAnsweredNonBusiness: 15,
          incomingMissedBusiness: 15,
          incomingMissedNonBusiness: 15,
          averageDurationOutbound: 15,
          averageDurationIncoming: 15,
          callsNotReturned: 15,
          callsReturned: 15,
        };
      } else
        return {
          name: 200,
          outboundTotal: 200,
          outboundBusiness: 200,
          outboundNonBusiness: 200,
          incomingTotal: 200,
          incomingBusiness: 200,
          incomingNonBusiness: 200,
          incomingAnsweredBusiness: 200,
          incomingAnsweredNonBusiness: 200,
          incomingMissedBusiness: 200,
          incomingMissedNonBusiness: 200,
          averageDurationOutbound: 200,
          averageDurationIncoming: 200,
          callsNotReturned: 200,
          callsReturned: 200,
        };
    });

    let sheetTitle = [`${convertAllDates(`${new Date(dateStart)}`, "PP")} Call Activity`];

    let phoneData = phoneTotals.map((phone: IPhoneTotal) => {
      return {
        ...phone,
      };
    });

    if (type === "excel") {
      downloadExcel([phoneData], [headers], [], [columnWidths], sheetTitle, sheetTitle[0]);
    } else {
      downloadPdf([phoneData], [headers], [], columnWidths, sheetTitle, sheetTitle[0]);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xl={12} sm={12}>
          <StandardTable title="Call Stats" loading={loading} user={user} download={download} columns={projectColumns} data={phoneTotals} />
        </Grid>
      </Grid>
    </Box>
  );
};

interface ChildProps {
  user: IUser | null;
  phoneTotals: IPhoneTotal[];
  dateStart: Date;
  dateEnd: Date;
  loading: boolean;
}
export default ReportCallTable;
